import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Planning module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it. The route is gated by dept.planning in allRoutes.js.
 */
const TOOLS = [
    "displayBoards", "tasks", "tasksDept", "cr", "projectsAwaiting",
    "epoMissing", "epoFindByItem", "dmsAll", "epoCreate",
];
const REPORTS = [
    "summary-otd", "blown-up-otd", "sales-dashboards-planning",
    "backlog-orders", "open-orders", "inventory-performance", "vendor-performance-kpi",
];

const Planning = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-calendar-todo-line"
                        eyebrow="Operations"
                        title="Planning"
                        subtitle="Schedules, capacity, and forecasts"
                        tone="blue"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Planning" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Planning tools"
                        description="Shop-floor status, tasks, contract reviews and shipments"
                        icon="ri-calendar-todo-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-calendar-todo-line"
                        title="More for Planning later"
                        message="Ideas for later: weekly capacity forecasts and machine load views. The cards above are live today."
                        tone="info"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Planning;
